/**
 * CarryForwardButton — small "↩ Last week" chip shown next to an
 * empty weekly field when the prior week's snapshot has content for
 * that field.
 *
 * Clicking it fills in the prior value via the provided `onApply`
 * callback; caller decides what that means (call save mutation for
 * sub-goal update; set local draft state for weekly summary fields).
 *
 * Compact footprint — designed to sit inside narrow table rows
 * alongside the placeholder text.
 */
export default function CarryForwardButton({
  onApply,
  disabled = false,
  label = '↩ Last week',
  title = "Bring over last week's value",
  preview = '',
  compact = false,
}) {
  if (disabled) return null
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation()
        onApply?.()
      }}
      title={preview ? `${title}: ${preview.slice(0, 120)}${preview.length > 120 ? '…' : ''}` : title}
      style={{
        padding: compact ? '1px 7px' : '3px 10px',
        border: '1px dashed var(--border)',
        background: '#fff',
        fontSize: compact ? 9 : 11,
        fontWeight: 600,
        color: 'var(--muted)',
        borderRadius: 99,
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        lineHeight: 1.3,
      }}
    >
      {label}
    </button>
  )
}
